// extracted by mini-css-extract-plugin
export default {"container":"bpXO00sxc2AiH7oke4Xk","wrapper":"NehB84R2L9kKuUXz0SXB"};